module.exports = __webpack_public_path__ + "static/media/tackle.09ce7f86.svg";